<template>
  <div class="service-box">
    <!--{{serviceType}}-->
    <div v-if="serviceType != 'None Type'">
      <div class="box1">
        <div class="item">
          <div class="title">Service</div>
          <div class="text" v-text="serviceType"></div>
        </div>
        <div class="item">
          <div class="title">Portfolio</div>
          <div class="text">{{ portfolioImages.length }} Sample images</div>
        </div>
        <div class="item">
          <div class="title">Price</div>
          <div class="text">
            <span v-currency="currency"></span>
            <span>{{ price }} /hours</span>
          </div>
        </div>
      </div>

      <div class="message-box">
        <div class="portfolio-images">
          <div
            class="item-image"
            v-for="(item, index) in portfolioImages"
            :key="index"
          >
            <img v-imageLoading="item.thumbnailFullPath" />
          </div>
        </div>
        <div class="buttons">
          <button class="decline" @click="deleteService">DELETE</button>
          <button class="accept" @click="edit">EDIT</button>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <div class="message">There is no service</div>
    </div>
  </div>
</template>

<script>
import mixinPrice from '@/mixin/price'
import mixCommon from '@/mixin/common'
import { defaultStore } from '@/library/firebase'

export default {
  mixins: [mixinPrice, mixCommon],
  name: 'service-box',
  props: {
    serviceType: {
      default: 'None Type',
      type: String
    },
    portfolioImages: {
      default: () => [require('@/assets/images/error/error.jpg')],
      type: Array
    },
    price: {
      default: 1000,
      type: Number
    },
    currency: {
      default: 'uk',
      type: String
    },
    serviceId: {
      default: '',
      type: String
    }
  },
  created() {
    // console.log(this.portfolioImages)
  },
  methods: {
    buttonAction(actionName) {
      this.$emit('action', { action: actionName, data: this.serviceId })
    },
    deleteService() {
      // this.$store.dispatch(storeTypes.SET_MODAL_ALERT, {active: true, text: 'Delete confirm ?'}).then(() => {
      //     console.log('modal answer:', this.$store.getters.modalAlertReturnProps)
      if (confirm('Are you delete?')) {
        defaultStore
          .collection('photographers_service')
          .doc(this.serviceId.toString())
          .update({ delete: true })
          .then(() => {
            this.$emit('action')
          })
      }
      // })
    },
    edit() {
      this.$router.push({
        path: '/photographer/service/edit',
        query: {
          id: this.serviceId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.service-box {
  border: 1px solid #c8c8c8;
  .box1 {
    background-color: #f5f5f5;
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    .item {
      width: 100%;
      height: 80px;
      &:nth-child(1) {
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(2) {
        border-right: 1px solid #c8c8c8;
      }

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
  }
  .message-box {
    height: 133px;
    display: flex;
    justify-content: space-between;
    .portfolio-images {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 7px;
      .item-image {
        margin-left: 14px;
        width: 74px;
        height: 110px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          object-fit: contain;
          width: 74px;
          height: 110px;
        }
      }
    }

    .contents {
      width: 70%;
      margin: 18px 0 18px 0;
      /*border: 1px dotted red;*/
      .author {
        font-weight: 600;
      }

      .comment {
        margin: 10px 0 0 0;
        width: 700px;
        height: 71px;
        /*border: 1px solid red;*/
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .buttons {
      width: 200px;
      /*border: 1px dotted green;*/
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      button {
        width: 150px;
        height: 50px;
        font-size: 14px;
        font-weight: 300;
        letter-spacing: 1px;
        cursor: pointer;
        outline: none;
      }

      .decline {
        background-color: white;
        border: 1px solid #c8c8c8;
        margin: 0 0 10px 0;
        &:active {
          color: #000000;
        }
      }

      .accept {
        border: 0;
        background-color: #000bff;
        color: white;
      }
    }
  }
  .no-data {
    height: 200px;
    position: relative;
    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }
    background-color: #f5f5f5;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
  }
}
</style>
